export default function CtaSection() {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        <div>
          <img
            src="https://static.readdy.ai/image/5da477fdae7b1d111ee386eccbf37db2/b4fb23672e3e87dd6693a5be34d96da1.png"
            alt="Estúdio Manaus Digital"
            className="w-full h-96 object-cover object-top rounded-3xl shadow-xl"
          />
        </div>
      </div>
    </section>
  );
}
